import React, { useCallback, useEffect, useState } from 'react';

import { Typography } from '@sravni/react-design-system';

import { getDictionary, getMaterials, getRubrics } from '../../services/news';
import commonStyles from '../../styles/common.module.scss';
import { Preloader } from '../ui/Card/Preloader';

import { BlocksLine } from './BlocksLine';
import styles from './materials.module.scss';
import { Tabs } from './Tabs';

const News = React.memo(() => {
  const [dictionary, setDictionary] = useState([]);
  const [rubrics, setRubrics] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [fetching, setFetchingStatus] = useState(true);

  const fetchDictionary = useCallback(async () => {
    if (!dictionary?.length) {
      let items;

      try {
        ({ items } = await getDictionary({ type: 'rubrics' }));
      } catch (error) {
        items = [];
      }

      setDictionary(items);
    }
  }, [dictionary]);

  const fetchRubrics = useCallback(async () => {
    if (!rubrics?.length) {
      let items;

      try {
        ({ items } = await getRubrics({ placement: 'homePage' }));
      } catch (error) {
        items = [];
      }

      setRubrics(items);
    }
  }, [rubrics]);

  const fetchMaterials = useCallback(async () => {
    if (!materials?.length) {
      let res;

      try {
        res = await getMaterials({
          limit: 8,
          placement: 'homePage',
          placementLimit: 3,
        });
      } catch (error) {
        res = [];
      }

      setMaterials(res);
    }

    setFetchingStatus(false);
  }, [materials]);

  useEffect(() => {
    setFetchingStatus(true);
    fetchDictionary();
    fetchRubrics();
    fetchMaterials();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const content =
    fetching || !materials?.length ? <Preloader /> : <BlocksLine items={materials} dictionary={dictionary} isVisible />;

  return (
    <div className={commonStyles.wrapper}>
      <div className={commonStyles.inner}>
        <a className={styles.headingLink} href={'/novosti/'}>
          <Typography.Heading level={2}>Журнал Сравни</Typography.Heading>
        </a>
        <Tabs rubrics={rubrics} />
        {content}
        <Typography.Text size={14}>
          <Typography.Link href={'/novosti/'} className={commonStyles['header-link']} strong>
            Весь журнал
          </Typography.Link>
        </Typography.Text>
      </div>
    </div>
  );
});

export default News;
